var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem, TabButton } from './subcomponents';
const Tab = (_a) => {
    var { handleTabClick, isActive = false, label, index, className, id, forwardRef } = _a, props = __rest(_a, ["handleTabClick", "isActive", "label", "index", "className", "id", "forwardRef"]);
    return (_jsx(ListItem, Object.assign({ showActiveStyles: isActive, className: className, role: "presentation" }, { children: _jsx(TabButton, Object.assign({ role: "tab", id: id, ref: forwardRef, tabIndex: isActive ? 0 : -1, "aria-selected": isActive, "aria-controls": `${id}-content`, showActiveStyles: isActive, onClick: () => {
                handleTabClick(index);
            } }, props, { children: label })) })));
};
export default Tab;
//# sourceMappingURL=Tab.js.map